import React, { useEffect, useState } from "react";
import { FaCog } from 'react-icons/fa';
import {ShortListTable} from "./ShortList/ShortListTable"
import { useHistory ,useLocation} from "react-router-dom";
import { OverlayTrigger, Tooltip,Alert } from "react-bootstrap";
import Cookies from "js-cookie"
import {
    Tabs,
    Tab,
    Typography,
    makeStyles
  } from '@material-ui/core';
  import PropTypes from "prop-types";
import axios from "axios";
import { NODE_API_URL ,BASE_URL } from "../../../env_config";
import { SwalWarn } from "../Popup";
import { CcmodeRule } from "./CCModeRule";
import { OrderHistoryDetail } from "./OrderHistory/OrderHistoryDetail";
import { CongratulateCCModeDashboardPopUp } from "../Popup/CongratulateCCModeDashboardPopUp";

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "end",
            gap: theme.spacing(1),
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
        }
    }
}));

export const CcmodeDashboard = (props) => {
    const classes = useStyles();
    const history = useHistory()
    const location = useLocation()
    const [updaterule,setUpdateRule] = useState("")
    const [swalopen,setSwalOpen] = useState(false)
    const [deleteObj,setDeleteObj] = useState(null)
    const [value, setValue] = useState(location.state && location.state.backfromShortlist ? 1 : 0);
    const [congratulatePopUp, setCongratulatePopUp] = useState(false);

    useEffect(() => {
        if(location.state && location.state.updatestatus){
            setUpdateRule("Please search again on CC MODE  for latest rule changes")
        }
        window.history.replaceState({}, document.title)

        if(props.ccmodesetting && props.ccmodesetting.length && !props.ccmodesetting[0].has_seen_dashboard_popup){
            setCongratulatePopUp(true)
        }
    },[])
   
    const DeleteRule = () => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/delete-ccmode-rules`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            data: {
                user_id:deleteObj.user_id,
                rule_id:deleteObj.rule_id,
                activity_type:"RuleDeleted",
                user_agent:navigator.userAgent
            },
        }).then(res => {
            if(res && res.data){
              
                props.setUpdateRules(!props.updaterule)
                setSwalOpen(false)
                setDeleteObj(null)
            }
        }).catch(error => {
            if(error?.response?.data?.message === "UnAuthorized!"){
              var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
              if(cookies[i] && !cookies[i].includes("view")){
                var equals = cookies[i].indexOf("=");
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
              }
            }
            
            window.location.replace(`${BASE_URL}/logout`);
          }
          })
    }
    
    function handleTabChange(event, newValue) {
        window.glob = newValue
        setValue(newValue);
    }


    return (
        <>
        <CongratulateCCModeDashboardPopUp show={congratulatePopUp} setShow={setCongratulatePopUp} ccmodesetting={props.ccmodesetting[0]} language={props.language} />
        {updaterule?<Alert variant="success">
                    {updaterule}
              </Alert>:""}
             
            <SwalWarn show={swalopen} message={"Are you sure want to delete Rule?"} onHide={() => setSwalOpen(false)} onClose={() => setSwalOpen(false)} responseOnOk={() => DeleteRule()}/>
            <div className="row align-content-start position-relative" style={{minHeight: "74vh"}}>
                <div className="col-12 pb-4">
                    <h3>CCMode Dashboard</h3>
                </div>
                <div className={`col-12 rounded bg-white border-bottom ${classes.container}`}> 
                        <Tabs variant="scrollable" value={value} onChange={handleTabChange}>
                            <Tab label="Mark-up rules Manager" />
                            {props.ccmodesetting[0].AllowLogin.data == 1 ?
                                <Tab label="Session Detail" />
                            :null}
                            {props.ccmodesetting[0].AllowLogin.data == 1 ?
                                <Tab label="Order History" />
                            :null}
                        </Tabs>
                    <div>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    Ccmode Settings
                                </Tooltip>
                            }
                        >
                            <button className="btn btn-text-dark btn-hover-light-dark"  onClick={() => history.push({ pathname: "/ccmode-setting", state: "ccmodesetting"})}><FaCog className="font-size-h4 mr-2"/>Settings</button>
                        </OverlayTrigger>
                    </div>
                </div>
                    {value === 0 && (
                        <div className="col-12 bg-white pt-3">
                            <TabContainer>
                                {props.ccmoderules.length ===0 ? <Alert variant="danger">
                                Please setup at least one rules to login to CC-Mode
                                </Alert>:"" }
                                {props.ccmoderules.map(value => value.status).every(element => element === 0) ? <Alert variant="danger">
                                Please activate at least one rule to Login to CC-Mode
                                </Alert>:"" }
                                <div className="mt-2 mb-2">Your Multi-level Markup for different types of Diamonds</div>
                                <CcmodeRule {...props}/>
                            </TabContainer>
                        </div>
                    )}
                    {props.ccmodesetting[0].AllowLogin.data == 1 ?
                        value === 1 && (
                            <div className="col-12 bg-white">
                                <TabContainer>
                                    <ShortListTable userinfo={props.userinfo} language={props.language}/>
                                </TabContainer>
                            </div>
                        )
                        :null
                    }
                    {props.ccmodesetting[0].AllowLogin.data == 1 ?
                        value === 2 && (
                            <div className="col-12 bg-white">
                                <OrderHistoryDetail userinfo={props.userinfo} conversionrate={props.conversionrate} symbol={props.symbol} symbolname={props.symbolname} language={props.language}/>
                            </div>
                        )
                        :null
                    }
            </div>
        </>
    );
};

